export default __webpack_public_path__ + "static/media/sommly-auth-login-bg.8091e84d.jpg";